module.exports = __webpack_public_path__ + "static/illustration-132321e8515073c383a30b578f1a9db6.png";